import React from "react";

import Navbar from "./components/Navbar";
import Routes from "./Routes";
import Footer from "./components/Footer";

const App = () => {
  return (
    <div className="app-wrapper">
      <Navbar />
      <div className="content-wrapper">
        <Routes />
      </div>
      <Footer />
    </div>
  );
};

export default App;
